import { useQuery } from 'react-query';

import { queries } from '~/constants/queryKeys';
import { dispatchError } from '~/containers/ErrorContainer/errorEventListener';
import { SentryHelper } from '~/helpers/Sentry/SentryHelper';
import { getProductPrice, type ProductPriceResponse } from '~/networking/api/managed/requests/pricing/getProductPrice';

/** Query for fetching a product's price */
export const useProductPrice = (productId?: number) => {
    return useQuery(
        [queries.getProductPrice, productId],
        async (): Promise<ProductPriceResponse | undefined> => {
            if (!productId) {
                return undefined;
            }
            try {
                const pricingData = await getProductPrice(productId);
                if (pricingData?.status === 200) {
                    return pricingData.data;
                }
                SentryHelper.captureMessage(`Failed to fetch product price: ${productId}`);
                return undefined;
            } catch (error) {
                SentryHelper.captureException(error, {
                    extra: {
                        productId
                    }
                });
                dispatchError(error);
            }

            return undefined;
        },
        {
            enabled: !!productId,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false
        }
    );
};
